import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'src/app/layout/header/header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ChartModule } from 'angular-highcharts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ShortNamePipe } from 'src/app/pipes/short-name.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MessageBoxComponent } from 'src/app/modules/message-box/message-box.component';
import { ToastrModule } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { CoolDialogsModule } from '@angular-cool/dialogs';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MAT_DATE_LOCALE } from '@angular/material/core'

@NgModule({
  declarations: [HeaderComponent, ShortNamePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ChartModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatPaginatorModule,
    MatButtonModule,
    MatDialogModule,
    RouterModule,
    OwlDateTimeModule,
    MatAutocompleteModule,
    OwlNativeDateTimeModule,
    CoolDialogsModule.forRoot(),
    MatMomentDateModule,
    NgMultiSelectDropDownModule.forRoot(),
    TooltipModule

  ],
  exports: [
    CommonModule,
    HeaderComponent,
    ChartModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatMenuModule,
    MatPaginatorModule,
    ShortNamePipe,
    RouterModule,
    CoolDialogsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatMomentDateModule,
    MatAutocompleteModule,
    NgMultiSelectDropDownModule,
    TooltipModule

  ],
  entryComponents: [MessageBoxComponent],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }

  ]

})
export class AppSharedModule { }
